import { RadioButton as NatDsRadioButton } from '@naturacosmeticos/natds-react'

export const FVRadioButton = NatDsRadioButton
